export const TYPES = {
  GET_MEDIA_SUCCESS: "media/GET_MEDIA_SUCCESS",
  GET_MEDIA_METADATA_SUCCESS: "media/GET_MEDIA_METADATA_SUCCESS",
  GET_RESIZE_METADATA_SUCCESS: "media/GET_RESIZE_METADATA_SUCCESS",
  GET_VIDEO_SUCCESS: "media/GET_VIDEO_SUCCESS",
  SET_MONTH_SUCCESS: "media/SET_MONTH_SUCCESS",
  GET_MEDIA_BY_BRANCH_BY_DATE_SUCCESS: "media/GET_MEDIA_BY_BRANCH_BY_DATE_SUCCESS",
};
